import { useTypedSelector } from "../store/reducers/use-typed-selector";
import { ENavbarTypes, FeatureFlagsEnum } from "../types/working-model";
import { useGetEvent } from "./session.hooks";

const newNavbarTypes = [ENavbarTypes.Horizontal, ENavbarTypes.Vertical];

export const useIsNewNavigation = (): boolean => {
	const event = useGetEvent();
	const featureFlags = useTypedSelector(state => state.FeatureFlagsReducer.featureFlags);
	const navbarFeatureFlag = featureFlags?.[FeatureFlagsEnum.navbar_v2];

	const navbarType = event?.settings.event_navbar?.navbarType as ENavbarTypes;

	return !!(newNavbarTypes.includes(navbarType) && navbarFeatureFlag);
};